import { render, staticRenderFns } from "./Lowest5Practices.vue?vue&type=template&id=e75a6354&"
import script from "./Lowest5Practices.vue?vue&type=script&lang=js&"
export * from "./Lowest5Practices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports